import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getSanAntonioStructuredData() {
  const url = "https://restorehair.com/locations/texas/san-antonio/";
  const description =
    "Find out about your hair transplant options in San Antonio with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("san-antonio", url, description),
    locationPageCrumbs(url, "San Antonio"),
  ];
}
